import { registerPlugin } from "@capacitor/core";

import { mTLSProxyPlugin } from "capacitor-mtls";

export const mTLSProxy = registerPlugin("mTLSProxy") as mTLSProxyPlugin;
